"use strict";
/**
 * Budget Model
 *
 * All monetary values (totalBudgeted, totalActual) are stored as integer pence
 * to avoid floating-point errors. Display in pounds sterling: (pence || 0) / 100
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BudgetType = exports.BudgetStatus = void 0;
/** Budget status - DRAFT, APPROVED, or CLOSED */
var BudgetStatus;
(function (BudgetStatus) {
    BudgetStatus["Draft"] = "DRAFT";
    BudgetStatus["Approved"] = "APPROVED";
    BudgetStatus["Closed"] = "CLOSED";
})(BudgetStatus = exports.BudgetStatus || (exports.BudgetStatus = {}));
/** Budget type - INCOME, EXPENSE, or SAVINGS */
var BudgetType;
(function (BudgetType) {
    BudgetType["Income"] = "INCOME";
    BudgetType["Expense"] = "EXPENSE";
    BudgetType["Savings"] = "SAVINGS";
})(BudgetType = exports.BudgetType || (exports.BudgetType = {}));
